






















import { Component, Vue } from "vue-property-decorator";
import RestaurantModule from "@/store/restaurant";
import Pagination from "@/components/Pagination.vue";

@Component({
  components: {
    Pagination,
  },
})
export default class RestaurantEditMenuList extends Vue {
  private get menus() {
    return RestaurantModule.menus;
  }

  private get editMenuStatus() {
    return RestaurantModule.editMenuStatus;
  }
}
